export const formatDate = (dateString: Date, nodata = '', get_hour = false) => {
    if (!dateString) return nodata;

    const date = new Date(dateString);

    //format date to dd/mm/yyyy
    const day = date.getDay();
    const month = date.getMonth() + 1;
    const year = date.getFullYear();

    let hourFormated = '';

    if (get_hour) {
        const hour = date.getHours();
        const minutes = date.getMinutes();
        hourFormated = ` ${hour}:${minutes}`;
    }

    return `${day}/${month}/${year}${hourFormated}`;
};


export function simpleCurrencyFormat(price: number | bigint, currency: string) {
    const newMoneyFormat = new Intl.NumberFormat('es-MX', {
        style: 'currency',
        currency: 'MXN',
        maximumFractionDigits: 0,
        minimumFractionDigits: 0,
    }).format(price);

    return `${newMoneyFormat} ${currency}`;
}


export function formatDateNotifications(isoDate) {
    const date = new Date(isoDate);

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Meses van de 0 a 11
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
};